<template>
  <div style="width: 100%;height: 100%;">
    <div class="top-title" style="display: flex;justify-content: center;">
      <el-button id="prev" size="mini" plain @click="onPrevPage">前一页</el-button>
      <span style="margin-right: 5px;">页码: <span id="page_num"></span> / <span id="page_count"></span></span>
      <el-button id="next" size="mini" plain @click="onNextPage">下一页</el-button>
      <el-button id="next" size="mini" plain @click="scaleLarge">放大</el-button>
      <el-button id="next" size="mini" plain @click="scaleSmall">缩小</el-button>
    </div>

    <div class="pdf-container">
      <div
        class="pdf-page"
        ref="pdfPage"
        @mousedown="startDragging"
        @mousemove="dragPage"
        @mouseup="stopDragging"
        @touchstart="startDragging"
        @touchmove="dragPage"
        @touchend="stopDragging"        
      >
        <canvas id="the-canvas" ref="pdfCanvas"></canvas>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PdfPage',
  data() {
    return {
      pdfjsLib: '',
      pdfPath: '',
      pdfDoc: null,
      scale: 1,
      pageNum: 1,
      pageRendering: false,
      pageNumPending: null,
      isDragging: false,
      isPinching: false,
      startMouseX: 0,
      startMouseY: 0,
      startScrollX: 0,
      startScrollY: 0,
      startDistance: 0,
    }
  },
  mounted() {
    const _self = this
    this.pdfPath = this.$route.query.pdfUrl
    this.pdfjsLib = window['pdfjs-dist/build/pdf']
    this.pdfjsLib.GlobalWorkerOptions.workerSrc = '//mozilla.github.io/pdf.js/build/pdf.worker.js'

    this.pdfjsLib.getDocument(this.pdfPath).promise.then((pdfDoc_) => {
      
      _self.pdfDoc = pdfDoc_;

      document.getElementById('page_count').textContent = _self.pdfDoc.numPages;

      _self.renderPage(_self.pageNum);
    })
  },

  methods: {
    startDragging(e) {
      if (e.touches && e.touches.length === 2) {
        // 记录触摸点之间的距离
        const touch1 = e.touches[0]
        const touch2 = e.touches[1]
        this.startDistance = Math.sqrt(
          (touch1.clientX - touch2.clientX) ** 2 +
            (touch1.clientY - touch2.clientY) ** 2
        )
        this.isPinching = true
      } else {
        // 开始拖动
        this.isDragging = true
        this.startMouseX = e.touches ? e.touches[0].clientX : e.clientX
        this.startMouseY = e.touches ? e.touches[0].clientY : e.clientY
        this.startScrollX = this.$refs.pdfPage.scrollLeft
        this.startScrollY = this.$refs.pdfPage.scrollTop
      }
    },
    dragPage(e) {
      if (this.isPinching) {
        // 处理缩放
        if (e.touches.length === 2) {
          const touch1 = e.touches[0]
          const touch2 = e.touches[1]
          const distance = Math.sqrt(
            (touch1.clientX - touch2.clientX) ** 2 +
              (touch1.clientY - touch2.clientY) ** 2
          )
          const scaleFactor = distance / this.startDistance
          this.scale *= scaleFactor
          this.startDistance = distance
          this.renderPage(this.pageNum)
        }
      } else if (this.isDragging) {
        // 处理拖动
        const deltaX = (e.touches ? e.touches[0].clientX : e.clientX) - this.startMouseX
        const deltaY = (e.touches ? e.touches[0].clientY : e.clientY) - this.startMouseY

        this.$refs.pdfPage.scrollLeft = this.startScrollX - deltaX
        this.$refs.pdfPage.scrollTop = this.startScrollY - deltaY
      }
    },
    stopDragging() {
      this.isDragging = false
      this.isPinching = false
    },  
    renderPage(num) {
      const _self = this
      const windowWidth = window.innerWidth
      const windowHeight = window.innerHeight
      const canvas = document.getElementById('the-canvas')
      // canvas.height = windowHeight - 48
      // canvas.width = windowWidth
      const ctx = canvas.getContext('2d')
      this.pageRendering = true;

      // Using promise to fetch the page
      this.pdfDoc.getPage(num).then((page) => {
        var viewport = page.getViewport({scale: _self.scale})
        // const scale = Math.min(canvas.width / viewport.width, canvas.height / viewport.height)
        canvas.height = viewport.height;
        canvas.width = viewport.width;
        // Render PDF page into canvas context
        var renderContext = {
          canvasContext: ctx,
          viewport: viewport
        }
        var renderTask = page.render(renderContext)

        // Wait for rendering to finish
        renderTask.promise.then(function() {
          _self.pageRendering = false
          if (_self.pageNumPending !== null) {
            // New page rendering is pending
            _self.renderPage(_self.pageNumPending)
            _self.pageNumPending = null
          }
        })
      })

      // Update page counters
      document.getElementById('page_num').textContent = num
    },

    scaleLarge() {
      this.scale += .1
      this.queueRenderPage(this.pageNum)
    },

    scaleSmall() {
      this.scale -= .1
      this.queueRenderPage(this.pageNum)
    },    

    queueRenderPage(num) {
      if (this.pageRendering) {
        this.pageNumPending = num;
      } else {
        this.renderPage(num);
      }
    },

    onPrevPage() {
      if (this.pageNum <= 1) {
        return;
      }
      this.pageNum--
      this.queueRenderPage(this.pageNum)
    },

    onNextPage() {
      if (this.pageNum >= this.pdfDoc.numPages) {
        return;
      }
      this.pageNum++;
      this.queueRenderPage(this.pageNum);
    }
  }
};
</script>
<style lang="scss" scoped>
.top-title{
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  .el-button{
    margin-right: 5px;
  }
}
.pdf-container {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.pdf-page {
  width: 100%;
  height: 100%;
  overflow: scroll;
  white-space: nowrap; /* 防止 PDF 页面换行 */
}

.pdf-page canvas {
  display: block;
  margin: 0 auto; /* 居中显示 */
}
</style>